import React from 'react';

import DropdownInput from './DropdownInput';

type Props = {
  onChange: (value: string) => void;
  value: string;
  isFilter?: boolean;
};

const assetStatuses = [
  {
    value: 'maintained',
    label: 'Maintained',
  },
  {
    value: 'due_soon',
    label: 'Due Soon',
  },
  {
    value: 'overdue',
    label: 'Overdue',
  },
  {
    value: 'out_of_service',
    label: 'Not In Service',
  },
];

function AssetStatusSelectInput({onChange, value, isFilter}: Props) {
  const options = isFilter ? [{value: 'ALL', label: 'All'}, ...assetStatuses] : assetStatuses;

  return (
    <DropdownInput
      label="Asset Status"
      name="assetStatus"
      placeholder=""
      onChange={onChange}
      value={value}
      options={options}
    />
  );
}

export default AssetStatusSelectInput;
